import { formatCurrency } from "@/lib/Formatters/formatCurrency";
import { Text } from "@/components/catalyst/text";
import { useSuspenseGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { contactCreditBalancesQuery } from "@/app/ContactCredits/GraphQL/contactCreditBalancesQuery";

export function ContactCreditBalances({ contactId }: { contactId: string }) {
  const { data } = useSuspenseGqlQuery(contactCreditBalancesQuery, {
    id: contactId,
  });

  const balances = data.contact.credit_balances;

  if (balances.length === 0) {
    return <Text>No credit is held for this contact.</Text>;
  }

  return (
    <dl className="grid grid-cols-1 gap-5 sm:grid-cols-3">
      {balances.map((balance) => (
        <div
          key={balance.currency}
          className="overflow-hidden rounded-lg bg-gray-50 px-4 py-5 shadow-sm sm:p-6"
        >
          <dt className="truncate text-sm font-medium text-gray-500">
            {balance.currency} available
          </dt>
          <dd className="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
            {formatCurrency(balance.amount, balance.currency, {
              showZero: true,
            })}
          </dd>
        </div>
      ))}
    </dl>
  );
}
